export const FETCH_WELCOMES_REQUEST = 'FETCH_WELCOMES_REQUEST'
export const FETCH_WELCOMES_SUCCESS = 'FETCH_WELCOMES_SUCCESS'
export const FETCH_WELCOMES_FAIL = 'FETCH_WELCOMES_FAIL'

export const SAVE_WELCOME_REQUEST = 'SAVE_WELCOME_REQUEST'
export const SAVE_WELCOME_SUCCESS = 'SAVE_WELCOME_SUCCESS'
export const SAVE_WELCOME_FAIL = 'SAVE_WELCOME_FAIL'

export const DELETE_WELCOME_REQUEST = 'DELETE_WELCOME_REQUEST'
export const DELETE_WELCOME_SUCCESS = 'DELETE_WELCOME_SUCCESS'
export const DELETE_WELCOME_FAIL = 'DELETE_WELCOME_FAIL'

export const WELCOME_TYPE_CHANGE = 'WELCOME_TYPE_CHANGE'

export const LOAD_WELCOME = 'LOAD_WELCOME'

export const PUBLISH_WELCOME = 'PUBLISH_WELCOME'
export const UNPUBLISH_WELCOME = 'UNPUBLISH_WELCOME'

export const CLEAR_WELCOME_STATE = 'CLEAR_WELCOME_STATE'
export const SORT_WELCOME_TYPE_CHANGE = 'SORT_WELCOME_TYPE_CHANGE'
export const SEARCH_WELCOME = 'SEARCH_WELCOME'

export const CHANGE_WELCOME_PAGE = 'CHANGE_WELCOME_PAGE'
export const CLEAR_SEARCH = 'CLEAR_SEARCH'
